import { useSelector } from 'react-redux'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Tabs } from '../../../../common/tabs'
import { formatVal } from '../../../../helpers/value'
import { selectAlertHighlight, selectLoading } from '../../store/slice'
import { ALERT_TYPES } from './helper'
import classes from './index.module.scss'

export const AlertTabs = ({ alertType, setAlertType }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const alertHighlight = useSelector(selectAlertHighlight())
  const isLoading = useSelector(selectLoading('alertHighlight'))

  const negativeAlertsText = UseI18n(
    'companySummary.companyAlerts.NEGATIVE_ALERT',
  )
  const unreadAlertsText = UseI18n('companySummary.companyAlerts.UNREAD_ALERT')
  const totalAlertsText = UseI18n('companySummary.companyAlerts.TOTAL_ALERT')

  const options = [
    {
      label: `${negativeAlertsText}: ${formatVal(
        alertHighlight?.totalAlertNegative,
        locale,
        false,
        0,
      )}`,
      key: ALERT_TYPES.NEGATIVE,
    },
    {
      label: `${unreadAlertsText}: ${formatVal(
        alertHighlight?.totalAlertUnread,
        locale,
        false,
        0,
      )}`,
      key: ALERT_TYPES.UNREAD,
    },
    {
      label: `${totalAlertsText}: ${formatVal(
        alertHighlight?.totalAlert,
        locale,
        false,
        0,
      )}`,
      key: ALERT_TYPES.TOTAL,
    },
  ]

  if (isLoading || Object.values(alertHighlight).every((i) => !i)) return null

  return (
    <Element className={classes.alertTabs} style={{ borderColor: '#B5CEF8' }}>
      <Tabs
        items={options}
        activeKey={alertType}
        onChange={setAlertType}
        tabListClassName={classes.tabList}
        getAppendStyleItem={(active) => ({
          backgroundColor: active ? '#2C73E8' : '#F3F3F3',
          color: active ? '#FFFFFF' : '#191D25',
          fontSize: 12,
          padding: '2px 8px',
        })}
      />
    </Element>
  )
}
